import React, { useEffect } from 'react';

//componets
import FlNav from './landingComponents/Navbar';
import FlFooter from './landingComponents/Footer';

//Mansory - Bento grid
import Masonry from 'react-masonry-css';

//Iconos
import icn_01 from '../../assets/img/landingPage/arcademy/icn_arcademy-01.png';
import icn_02 from '../../assets/img/landingPage/arcademy/icn_arcademy-02.png';
import icn_03 from '../../assets/img/landingPage/arcademy/icn_arcademy-03.png';
import icn_04 from '../../assets/img/landingPage/designer/icn_Desginer-02.png';


import fondo from '../../assets/img/landingPage/fondo.png';
import ReactGA from 'react-ga4'
import logo from '../../assets/img/logos/AVAP_Arcademy_negativo.svg'

import Favicon from '../../assets/img/Favicon_AVAP_Framework.png'

//Importaciones de otros archivos, revisar y borrar
import gradientApi from '../../assets/img/landingPage/gradientApi.png'
import gradientServices from '../../assets/img/landingPage/gradientServices.png'

import product_gateway from '../../assets/img/landingPage/Gateway.png'
import dashboard from '../../assets/img/landingPage/arcademy/arcademy-dashboard.png';

import icn_vision from '../../assets/img/landingPage/about/aboutUs_vision.svg';
import icn_mision from '../../assets/img/landingPage/about/aboutUs_mision.svg';


const Arcademy = () => {


    useEffect(() =>{

        if (/*config.url != 'https://avs-primary-pre.101obex.mooo.com' &&*/ true){
            ReactGA.initialize('G-08SZKPG9V0');
            ReactGA.send({ hitType: 'pageview', page: window.location.pathname, title: '101OBEX, CORP About Page' });
            }

    }, [])


    useEffect(() =>{

        if (/*config.url != 'https://avs-primary-pre.101obex.mooo.com' &&*/ true){
            ReactGA.initialize('G-08SZKPG9V0');
            ReactGA.send({ hitType: 'pageview', page: window.location.pathname, title: '101OBEX, CORP About Page' });
            }

    }, [])

    useEffect(() => {
        // favicon 
        const link = document.createElement('link');
        link.rel = 'icon';
        link.href = Favicon; // Usa la ruta importada directamente
        document.head.appendChild(link);
    
        // clean favicon 
        return () => {
          document.head.removeChild(link);
        };
      }, []);

    useEffect(() => {

        document.body.classList.add('dark-bg');
        return () => {
            document.body.classList.remove('dark-bg');
        };

    }, []);

    const productDetailsA = {
        Key_Feature_01: {
            title: 'From Gaming to Coding. Unleash the Power of Programming',
            text: "Hands-on projects turn gameplay into learning. Build your own games, experiment with code, and discover the logic behind APIs and software systems, all in an interactive, supportive environment.",
            altDescription: "Hands-on projects turn gameplay into learning. Build your own games, experiment with code, and discover the logic behind APIs and software systems, all in an interactive, supportive environment.",
            image: icn_01,
        },
        Key_Feature_02: {
            title: "Collaborative & Social Learning",
            text: "Work together through in-platform chat, collaborate on projects, and learn from peers. AVAP Arcademy makes coding a social, interactive experience, so no one has to learn alone.",
            altDescription: "Work together through in-platform chat, collaborate on projects, and learn from peers. AVAP Arcademy makes coding a social, interactive experience, so no one has to learn alone.",
            image: icn_02,
        },
        Key_Feature_03: {
            title: 'Track Your Progress & Earn Recognition',
            text: "Unlock badges, earn digital credentials, and showcase your achievements. Every step you take builds a portfolio that demonstrates skills, creativity, and dedication.",
            altDescription: 'Unlock badges, earn digital credentials, and showcase your achievements. Every step you take builds a portfolio that demonstrates skills, creativity, and dedication.',
            image: icn_03,
        },
        Key_Feature_04: {
            title: 'Flexible & Scalable',
            text: 
            "Arcademy fits any learning environment, from homes and coding clubs to schools and innovation labs. Accessible across devices and languages, the platform grows with its learners.",
            altDescription: 'Arcademy fits any learning environment, from homes and coding clubs to schools and innovation labs. Accessible across devices and languages, the platform grows with its learners.',
            image: icn_04,
        },
    }
      

    return (
        <>
            <FlNav></FlNav>
            <div id="pricing"
            className="fl-cloud-product bg-black text-white"
            style={{ backgroundImage: `url(${fondo})` }}
            >
                {/* Hero Section */}
                <section id="heroProduct" 
                className="text-center pt-5">
                    <img
                        src={logo}
                        alt="Logo AVAP Cloud"
                        className="img-fluid logo"
                    />
                    <h1 className="fl-title m-0">Discover Your Tech Side</h1>
                    <p className="fl-subtitle pb-0 fl-txt-container-s">
                    Turn curiosity into code through the universal language of gaming.
                    </p>
                </section>

                {/* Powerful API Platform */}
                <section className="text-center pb-8">
                    <img
                        src={dashboard}
                        alt="AVAP Cloud illustration displaying API Manager Service components including Devs & Organizations, Managed APIs, IAM, credentials, API Projects, API Catalog, Dev Portal, Gateway Manager, BRUNIX AI, and AI analytics."
                        className="img-fluid mt-4"
                        style={{ width: '80%', maxWidth: '900px', height: 'auto' }}
                    />
                    <h2 className="fl-title m-4 pt-8">Learn to Code Through Play</h2>
                    {/*<p className="fl-subtitle-xs mb-3">
                        Manage the entire API lifecycle in a SaaS model from <br /> design to testing and deployment.
                    </p>*/}
                    <p className="fl-text fl-txt-container-s">
                    AVAP Arcademy invites teens and young learners to explore programming in a fun, game-based environment. From building video games to creating APIs, the platform blends creativity with real-world coding skills, using block-based programming, JavaScript, Python, and hands-on API development.
                    </p>
                    <p className="fl-text fl-txt-container-s">
                    Designed for learners aged 9–18, Arcademy takes kids into real coding projects, fostering confidence, curiosity, and problem-solving skills from day one.
                    </p>
                    {/*Boton Contact Us*/}  
                    <a className="glowBtn-dark " style={{zIndex: 2}} href="/contact" target='_blank'><span className="btnInner">   Start Today  </span></a> 
                </section>

                

                {/* Sección Key Features */}
                <div className="fl-wrapper">
                    <img src={gradientServices} className="gradient gradientServices" alt="" />
                    <img src={gradientApi} alt="" className="gradient gradientlife" />
                    <div className="fl-container">
                        <section id="products">
                            {/*   <h3 className="fl-title text-center">Our Products & Services</h3> */}
                            <br />
                            &nbsp;
                            <br />&nbsp;
                            <p className="fl-title-center m-0">Key Features</p>
                            <div className="fl-productsWrapper">
                                {Object.keys(productDetailsA).map((productKey, index) => (
                                    <div key={productKey} className="fl-product-item">
                                        <div className={`row align-items-center ${index % 2 === 0 ? '' : 'flex-row-reverse'}`}>
                                            <div className="col-md-9">
                                                <div className="product-content">
                                                    <h3 className="fl-subtitle">
                                                        {productDetailsA[productKey].title}
                                                    </h3>
                                                    <p className="fl-text">
                                                        {productDetailsA[productKey].text}
                                                    </p>
                                                    
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <img
                                                    src={productDetailsA[productKey].image}
                                                    alt={productDetailsA[productKey].altDescription}
                                                    className="img-fluid product-preview"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            {/*Boton Contact Us*/}  
                            <a className="glowBtn-dark " style={{zIndex: 2}} href="/contact" target='_blank'><span className="btnInner">   Start Today  </span></a> 
                        </section>
                    </div>
                </div>

                <br />
                <br />
            </div>
            <FlFooter></FlFooter>
        </>
    );
};

export default Arcademy;
